// src/Redux/ToDo/TaskReducer.js
import {
    CHANGE_BOARD_PRIVACY_REQUEST,
    CHANGE_BOARD_PRIVACY_SUCCESS,
    CHANGE_BOARD_PRIVACY_FAIL,
    GET_BOARD_RESOURCE_USAGE,
    GET_MEMBER_WORKLOAD,
  } from './boardTypes';
import { selectBoardResourceConflictAlerts } from '../../../Funcs/resourceConflictFromBoard.js';
  
  // حالت اولیه
  const initialState = {
    privacyLoading: false,
    privacyError: null,
    privacyUpdated: false,
    lastUpdatedBoard: null
  };
  
  export const boardPrivacyReducer = (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_BOARD_PRIVACY_REQUEST:
        return {
          ...state,
          privacyLoading: true,
          privacyError: null,
          privacyUpdated: false
        };
  
      case CHANGE_BOARD_PRIVACY_SUCCESS:
        return {
          ...state,
          privacyLoading: false,
          privacyUpdated: true,
          lastUpdatedBoard: {
            boardId: action.payload.boardId,
            privacyMood: action.payload.privacyMood,
            updatedAt: new Date().toISOString()
          }
        };
  
      case CHANGE_BOARD_PRIVACY_FAIL:
        return {
          ...state,
          privacyLoading: false,
          privacyError: action.payload,
          privacyUpdated: false
        };
  
      default:
        return state;
    }
  };

const resourceUsageInitialState = {
  ok: true,
  conflicts: [],
  resources: [],
};

export const resourceUsageReducer = (state = resourceUsageInitialState, action) => {
  switch (action.type) {
    case GET_BOARD_RESOURCE_USAGE:
      return {
        ...state,
        ok: action.Payload.ok,
        conflicts: action.Payload.conflicts ?? [],
        resources: action.Payload.resources ?? [],
      };
    default:
      return state;
  }
};

/** Shortages from today onward (local calendar), same rules as Resource Timeline. */
export const selectResourceConflicts = selectBoardResourceConflictAlerts;

export const selectResourceUsageOk = (state) =>
  state.resourceUsage?.ok ?? true;

export const selectBoardResources = (state) =>
  state.resourceUsage?.resources ?? [];

const memberWorkloadInitial = {
  loading: false,
  data: null,
  error: null,
};

export const memberWorkloadReducer = (
  state = memberWorkloadInitial,
  action,
) => {
  switch (action.type) {
    case GET_MEMBER_WORKLOAD:
      return {
        ...state,
        ...(action.Payload || {}),
      };
    default:
      return state;
  }
};

export const selectMemberWorkload = (state) =>
  state.memberWorkload ?? memberWorkloadInitial;